import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IonicModule } from '@ionic/angular';
import { SharedModule } from '@shared/shared.module';
import { ActionsGridComponent } from './components/actions-grid/actions-grid.component';
import { CardHeaderComponent } from './components/card-header/card-header.component';
import { ContentSectionComponent } from './components/content-section/content-section.component';
import { YoutubePlayerComponent } from './components/youtube-player/youtube-player.component';
import { InformePensionesRoutingModule } from './informe-pensiones-routing.module';
import { InformePensionesHomeComponent } from './pages/informe-pensiones-home/informe-pensiones-home.component';


@NgModule({
  declarations: [
    InformePensionesHomeComponent,
    CardHeaderComponent,
    ContentSectionComponent,
    ActionsGridComponent,
    YoutubePlayerComponent
  ],
  imports: [
    CommonModule,
    InformePensionesRoutingModule,
    IonicModule,
    SharedModule,
  ]
})
export class InformePensionesModule { }
